// @flow
import { combineReducers, type CombinedReducer } from 'redux';

// import whiteboard from './whiteboard';
import managedUsers from './managed-users';
import user from './user';
import apiUrl from './apiUrl';
import presignedPosts from './presigned-posts';
import productNotes from './product-notes';
import barcodeScanning from './barcode-scanning';
import externalPrices from './external-prices';
import newOrder from './new-order';
import quikOrderHistory from './quik-order-history';
import inventory from './inventory';
import type { Action } from '../actions';

const reducers = {
  managedUsers,
  apiUrl,
  user,
  presignedPosts,
  productNotes,
  barcodeScanning,
  externalPrices,
  newOrder,
  quikOrderHistory,
  inventory,
  /* whiteboard, */
};

export type Reducers = typeof reducers;

type $ExtractFunctionReturn = <V>(v: (...args: any) => V) => V;
export type RawState = $ObjMap<Reducers, $ExtractFunctionReturn>;

export type State = {|
  // 🤔 I don't know if this is the right place for this (the api url). I
  // put in the store since I need to be able to access it from thunks, and this
  // seemed like a better idea than putting it in React settings context and passing
  // it around all the time.
  apiUrl: string,
  ...RawState,
|};

export default (combineReducers<typeof reducers, Action>(
  reducers,
): CombinedReducer<State, Action>);
